import Layers from "slotworks/graphics/layers/layers";
import AbstractStepperControl from "slotworks/smart-ui/controls/abstract/abstract-stepper-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class AutoplayLossLimitStepperControl extends AbstractStepperControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.stepperComponent.formatFunction = formatMoneyAsCurrency;
        this.stepperComponent.onUpdate.add(this.onStepperUpdated);
    }

    public updateOptions(options: ControlOptions) {
        if (!this.setupData) {

            const limitValues = options.getValidLossLimits();

            if (!limitValues || limitValues.length === 0) {
                this.setVisible(false);
            } else {
                this.setupValues(limitValues, this.getCurrentValue(options));
            }

            this.setupData = true;
        } else {
            this.setSelectedValue(this.getCurrentValue(options));
        }

        this.setValueVisible(!options.customLossLimitSelected);
    }

    private getCurrentValue(options: ControlOptions) {
        if (options.lossLimit.currentValue < options.getTotalStake()) {
            if (this.range) {
                return this.range[0];
            } else {
                return 0;
            }
        } else {
            return options.lossLimit.currentValue;
        }
    }

    private onStepperUpdated = (value: number) => {
        const options = new ControlOptions();
        options.lossLimit.currentValue = value;
        options.customLossLimitSelected = false;

        this.onChange.dispatch(options);
    }
}
